import { EColorVariablesV2 } from '@/types/theme-packs.types';
import ProjectColorText from '@ui/text/text/project-color-text';

const EditTextWrapper = () => {
  return (
    <ProjectColorText
      contrastAgainstAppBackground
      data-component="EditTextWrapper"
      colorVariable={EColorVariablesV2.accents}
      className="L2"
    >
      Edit
    </ProjectColorText>
  );
};

export default EditTextWrapper;
